module.exports = __webpack_public_path__ + "img/play-error-img-4.b3a9e143.png";